// eslint-disable-next-line eol-last
export const SET_TRANSACTION_HISTORY_OFFICE = "SET_TRANSACTION_HISTORY_OFFICE"
